var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(_vm.messages, function (message) {
      return _c(
        "div",
        { class: _vm.getMessageClass(message), attrs: { role: "alert" } },
        [
          message.dismissable
            ? _c(
                "a",
                {
                  staticClass: "close",
                  attrs: {
                    href: "#",
                    "data-dismiss": "alert",
                    "aria-label": "close",
                  },
                },
                [_vm._v("×")]
              )
            : _vm._e(),
          _vm._v("\n\t\t" + _vm._s(message.content) + "\n\t"),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }